import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const ThunderIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M13.3759 2.07332C13.8016 2.24602 14.0549 2.68659 13.9899 3.14141L13.153 8.99999H19C19.3761 8.99999 19.7204 9.21104 19.8911 9.54621C20.0618 9.88138 20.03 10.284 19.8087 10.5882L11.8087 21.5882C11.5385 21.9597 11.0499 22.0994 10.6241 21.9267C10.1984 21.754 9.94507 21.3134 10.01 20.8586L10.847 15H5C4.62387 15 4.27956 14.7889 4.10888 14.4538C3.9382 14.1186 3.97003 13.716 4.19126 13.4118L12.1913 2.41182C12.4615 2.04025 12.9501 1.90063 13.3759 2.07332ZM6.96377 13H12C12.2899 13 12.5655 13.1258 12.7555 13.3448C12.9454 13.5638 13.0309 13.8544 12.9899 14.1414L12.5593 17.1557L17.0362 11H12C11.7101 11 11.4345 10.8742 11.2445 10.6552C11.0546 10.4362 10.9691 10.1455 11.01 9.85857L11.4407 6.84426L6.96377 13Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

ThunderIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(ThunderIcon);
